import {
  getMoreViolations,
  historyType,
  onClickPay,
  ServiceSubCategory,
  serviceType,
} from '@/commonTypes';
import PageCard from '@/components/general/PageCard';
import { useLayoutContext } from '@/context/LayoutContext';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import React from 'react';
import LiveInquiry from '../LiveInquiry';
import ViolationSummary from '../ViolationSummary';
import styles from '../../styles.module.css';
import LivePill from '../LivePill';
import SingleViolationResult from './SingleViolationResult';
import MyPlatesTotal from '@/components/pages/plates/MyPlatesContent/MyPlatesTotal';
import Button from '@/components/common/Button';

export default function ServiceResultViolation({
  data,
  onClickPay,
  violationCount,
  getMoreViolations,
  subCategoryInfo,
  lastHistoryInfo,
  callBackHistory,
  imagesService,
  loadingViolations = false,
}: {
  data?: ServiceSubCategory;
  onClickPay?: onClickPay;
  violationCount?: string | number;
  getMoreViolations?: getMoreViolations;
  subCategoryInfo?: ServiceSubCategory;
  lastHistoryInfo?: historyType;
  callBackHistory?: any;
  imagesService?: ServiceSubCategory;
  loadingViolations?: boolean;
}) {
  const { activeCar } = useLayoutContext();
  const d = {
    label: 'مبلغ کل قابل پرداخت',
    value: data?.response?.inquire_price ? data?.response?.inquire_price : '0',
    showDiscount: false,
  };
  console.log('dataaaaaaa', data, data?.items?.[0]?.service_id);
  return (
    <>
      <PageCard
        title={`
      نتیجهٔ
      ${subCategoryInfo?.title}
      `}
        text={
          <div className={`${styles.violationText}`}>
            {activeCar && (
              <>
                {activeCar?.plate && (
                  <span>
                    {activeCar?.plate?.a} {activeCar?.plate?.b} {activeCar?.plate?.c}
                  </span>
                )}
                {activeCar?.name && <span> - {activeCar?.name}</span>}
              </>
            )}
          </div>
        }
        icon={<MainIcons.carIcon width="20px" height="20px" fill="var(--paper)" />}
        backgroundIcon={avatarBg(0)}
        className={`${styles.pageCard} ${styles.pageCardViolation}`}
        aside={<LivePill />}
      >
        <LiveInquiry
          data={data}
          onClickPay={onClickPay}
          lastHistoryInfo={lastHistoryInfo}
          subCategoryInfo={subCategoryInfo}
          callBackHistory={callBackHistory}
        />
        {data && <ViolationSummary data={data} />}
        <SingleViolationResult
          data={data}
          onClick={onClickPay}
          // violationCount={violationCount}
          getMoreViolations={getMoreViolations}
          imagesService={imagesService}
          callBackHistory={callBackHistory}
          loadingViolations={loadingViolations}
        />
        {data?.response?.inquire_price != 0 && (
          <MyPlatesTotal d={d}>
            <Button
              className={`btn btn-primary squareButton noBoxShadow`}
              onClick={() => {
                onClickPay &&
                  onClickPay(
                    'pay',
                    {
                      ...data,
                      price: data?.response?.inquire_price,
                      history_id: data?.id,
                      service_id: data?.items?.[0]?.service_id,
                    },
                    callBackHistory,
                  );
              }}
              disabled={!data?.items || data?.items?.length == 0}
            >
              <MainIcons.LockIcon fill="var(--paper)" width="17px" height="17px" />
              پرداخت یکجای همه
            </Button>
          </MyPlatesTotal>
        )}
      </PageCard>
    </>
  );
}
